.priceDrop {
  display: flex;
  position: relative;
  align-items: center;
  margin: 0 0 0 -1rem;
  padding: 0.5rem 0 0.5rem 1rem;
  cursor: pointer;
  gap: 1rem;

  &:hover {
    .details {
      .sub {
        .store {
          color: var(--primary-600);
        }
      }
    }
  }

  &.viewed,
  &.skeleton {
    .sub {
      .indicator {
        opacity: 0;
      }
    }
  }

  &.skeleton {
    .price {
      .divider {
        display: none;
      }
    }
  }

  .media {
    display: flex;
    flex: 0 0 auto;
    width: 5.75rem;
    padding: 0.625rem;
    border-radius: 1rem;
    aspect-ratio: 1 / 1;

    img {
      z-index: 10;
      width: 100%;
      max-width: 100%;
      height: 100%;
      max-height: 100%;
      margin: auto;
      border-radius: 0.625rem;
      background-color: var(--neutral);
      box-shadow:
        0 1rem 2.5rem rgba(14, 33, 24, 0.05),
        0 0.25rem 1rem rgba(14, 33, 24, 0.025);
      object-fit: contain;
    }

    .mediaSkeleton {
      width: calc(100% + 1.25rem);
      margin: -0.625rem;
      border-radius: 1rem;
      overflow: hidden;
    }
  }

  .details {
    flex: 1;

    .sub {
      display: flex;
      align-items: center;

      .store {
        opacity: 0.8;
        margin: 0 0 0.25rem;
        color: var(--neutral-500);
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.05rem;

        .storeSkeleton {
          width: 5rem;
          height: 1rem;
        }
      }

      .indicator {
        z-index: 50;
        position: relative;
        bottom: 0.1875rem;
        flex: 0 0 auto;
        width: 0.375rem;
        height: 0.375rem;
        margin: 0 0 0 0.375rem;
        border-radius: 99rem;
        background-color: var(--primary-500);
      }
    }

    .name {
      display: -webkit-box;
      max-width: 100%;
      overflow: hidden;
      line-height: 150%;
      text-overflow: ellipsis;
      word-break: break-word;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

      .nameSkeleton {
        height: 1.125rem;

        &:first-child {
          width: 100%;
          max-width: 16.5rem;
          margin: 0.0625rem 0 0;
        }

        &:last-child {
          width: 80%;
          max-width: 13.25rem;
          margin: 0.25rem 0 0.125rem;
        }
      }
    }

    .price {
      display: flex;
      align-items: baseline;
      margin: 0.25rem 0 0;

      .divider {
        position: relative;
        top: 0.0625rem;
        margin: 0 0.375rem;

        svg {
          width: 1rem;
          height: 1rem;
          color: var(--neutral-500);
        }
      }

      .priceSkeleton {
        width: 3.5rem;
        height: 1.375rem;
      }
      .previousPrice {
        text-decoration: line-through;

        .priceSkeleton {
          margin: 0 0 -0.25rem;
        }
      }

      .currentPrice {
        .priceSkeleton {
          margin: 0 0 -0.25rem 0.25rem;
        }
      }
    }
  }
}
